import React from 'react'
import {useState} from 'react'
import { addStep } from './firebase';
import Button from '@mui/material/Button';
import { useAuth } from "./AuthContext";

/*
we should be able to configure which ones to turn on off
Chain Id

Description
Title
Previous Id (options List)
Next Id (options list)

Decide: asat 24April 2024 Use <input> for fast prototyping


Must relearn event handling using JS and React
*/



function Propose() {

    // do you need an array for an object?
    // maybe initialise with empty
    const [proposal, setProposal] = useState({
        Title: '',
        Description:'',
        previousID:'',
        nextId:''
    });

    const { user, state, loginWithEmail, loginWithGoogle, logout } = useAuth(); //this is the authprovider




/* =================Event Handlers ====================== */
const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    console.log("Change detected at ", name, 'with value', value);
    setProposal(values => ({...values, [name]:value}))
}

const handleSubmit = (event) => {
    console.log('butto click');
    const name = event.target.name;
    const value = event.target.value;
    console.log("Change detected at ", name, 'with value', value);
    addStep();
}
// should have a variable that checks if a user is logged in or not
// then conditionally render a login button if anynomouse
// or conditionally render not a login button


    return (
        <div>
<Button variant="contained" color='error' onClick={logout}>Logout</Button>    
  {/*
  
            <h1>This is the Propose New Option for Thread on (Add Thread Title)</h1>
            
            <label>Title <input type="text" onChange={handleChange} name="Title" value={proposal.Title || ""} /></label>
            <div className='journey-decision'>
            <label>Description <textarea onChange={handleChange} name="Description" value={proposal.Description || ""} /></label>
            </div>  
                <button onClick={handleSubmit}>Submit</button>
  */
  }
        </div>
    )
}



export  {Propose};